import React, { Suspense } from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"

import {
  FirebaseAppProvider,
  AuthProvider,
  FirestoreProvider
} from "reactfire"

import { app, auth, db } from "./firebase-config"

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
  <React.StrictMode>
    <FirebaseAppProvider firebaseApp={app}>
      <AuthProvider sdk={auth}>
        <FirestoreProvider sdk={db}>
          <BrowserRouter>
            <Suspense fallback={<div>Cargando Firebase...</div>}>
              <App />
            </Suspense>
          </BrowserRouter>
        </FirestoreProvider>
      </AuthProvider>
    </FirebaseAppProvider>
  </React.StrictMode>
)
